import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ICONS } from '@gfe/core/services/icons/icons.service';

export type SplitTarget = 'split' | 'left' | 'right';

const SPLIT_ICONS: Record<SplitTarget, string> = {
  split: ICONS.squareSplitHorizontal,
  right: ICONS.arrowRight,
  left: ICONS.arrowLeft
};

@Component({
  selector: 'app-entity-detail-tabs',
  imports: [TranslatePipe, CdkDropList, CdkDrag],
  templateUrl: './entity-detail-tabs.component.html',
  styles: ``
})
export class EntityDetailTabsComponent {
  protected readonly ICONS = ICONS;
  protected readonly SPLIT_ICONS = SPLIT_ICONS;

  uids = input.required<string[]>();
  activeUid = input<string | null>(null);
  /**
   * Where a tab's split button sends it: `'split'` opens the right side, `'left'`/`'right'`
   * move it to the side already open there. `null` hides the button.
   */
  splitTarget = input<SplitTarget | null>(null);
  listId = input.required<string>();
  /**
   * The other strips a tab may be dropped onto. Listed explicitly rather than through a
   * `cdkDropListGroup`, which would also connect every drop list inside the detail body,
   * such as the table's column header, and let a tab land among the columns.
   */
  connectedTo = input<string[]>([]);

  activate = output<string>();
  closeOne = output<string>();
  closeAll = output<void>();
  split = output<string>();
  dropped = output<CdkDragDrop<unknown, unknown, string>>();
}
